import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BookingApi } from 'src/lib/repository/booking/booking.api';
import { IBookingDocumentDto } from 'src/lib/repository/booking/booking.model';

export const bookingDocumentListResolver: ResolveFn<IBookingDocumentDto[]> = (
  route,
) => {
  const bookingApi = inject(BookingApi);
  let { sort } = route.queryParams;

  if (Array.isArray(sort)) {
    sort = sort.filter((s) => s.length);
  }

  return bookingApi.findPageDocument({
    size: 100,
    bookingType: route.parent?.data['bookingType'],
    ...route.queryParams,
    sort: sort?.length ? sort : 'id,desc',
  });
};
